export enum AdminViewTabName {
	ProjectTags = "project-tags",
	Users = "users",
	SellerProfile = "seller-profile",
}
